import React from 'react';

const SectionCenterFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path fill="#010101" d="M8 20h8v-4H8v4zM4 10h16v4H4zM4 4h16v4H4z" />
    </svg>
);

SectionCenterFillSvg.displayName = 'SectionCenterFillSvg';
export default SectionCenterFillSvg;
